export default __webpack_public_path__ + "src/images/f1011200bbf9a28f5b8618472dd06521-transparent-logo.png";